module.exports = __webpack_public_path__ + "static/media/twitter.a01b1604.png";